/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductSkuQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ProductSkuQueryOperator");
    }

    getFixupPrototypeFunction() { return ProductSkuQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ProductSkuQueryOperator>): ProductSkuQueryOperator {
        let obj = Object.assign(new ProductSkuQueryOperator(), model);
        ProductSkuQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductSkuQueryOperator>): ProductSkuQueryOperator {
        if (!model) return null;
        return ProductSkuQueryOperator.newInstance(<ProductSkuQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductSkuQueryOperator) {
        if (!obj) return;

        models.ProductSkuQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductSkuQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProductSkuQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Product SKUs to include
     */
    product_skus: Array<string>;

}
